// client/src/components/common/EmptyState.jsx
//
// Shared "nothing here yet" state — distinct from an error. An empty list is a
// normal outcome, so it is announced politely and styled as an informational
// note rather than a failure.
//
// Uses the .note.info surface from styles/surfaces.css so the text sits on an
// explicit background in every theme.
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @param {object}    props
 * @param {string}    [props.message]  Pre-resolved message.
 * @param {string}    [props.messageKey='common.noResults']  i18n key.
 * @param {React.ReactNode} [props.action]  Optional CTA (e.g. a "New post"
 *   button) rendered under the message.
 * @param {string}    [props.className='']
 */
export default function EmptyState({
  message,
  messageKey = 'common.noResults',
  action,
  className = '',
}) {
  const { t } = useTranslation();
  const text = message || t(messageKey);

  return (
    <div
      className={`note info note-block empty-state ${className}`.trim()}
      role="status"
      aria-live="polite"
      data-testid="empty-state"
    >
      <div className="empty-state__message">{text}</div>
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
}
